/**
 * NAD Promo Topbar
 * Renders a live countdown (Xd HH:MM:SS) toward a fixed end timestamp.
 */
export class NADPromoTopbar {
  private element: HTMLElement;
  private countdownEl: HTMLElement | null;
  private endMs: number;
  private showDays: boolean;
  private hideOnEnd: boolean;
  private timer: ReturnType<typeof setInterval> | null = null;

  constructor(element: HTMLElement) {
    this.element = element;
    this.countdownEl = element.querySelector('[data-countdown]');
    const endSec = parseInt(element.getAttribute('data-countdown-end') || '0', 10);
    this.endMs = Number.isFinite(endSec) ? endSec * 1000 : 0;
    this.showDays = element.getAttribute('data-show-days') !== 'false';
    this.hideOnEnd = element.getAttribute('data-hide-on-end') === 'true';

    if (this.countdownEl && this.endMs > 0) {
      this.init();
    }
  }

  private init(): void {
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  private tick(): void {
    let remaining = Math.floor((this.endMs - Date.now()) / 1000);
    if (remaining <= 0) {
      this.onEnd();
      return;
    }

    const days = this.showDays ? Math.floor(remaining / 86400) : 0;
    remaining -= days * 86400;
    const hours = Math.floor(remaining / 3600);
    remaining -= hours * 3600;
    const minutes = Math.floor(remaining / 60);
    const seconds = remaining - minutes * 60;

    const pad = (n: number): string => n.toString().padStart(2, '0');
    let out = '';
    if (this.showDays && days > 0) out += `${days}d `;
    out += `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;

    if (this.countdownEl) this.countdownEl.textContent = out;
  }

  private onEnd(): void {
    if (this.timer != null) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.countdownEl) this.countdownEl.textContent = '00:00:00';
    if (this.hideOnEnd) this.element.setAttribute('hidden', '');
  }

  public destroy(): void {
    if (this.timer != null) clearInterval(this.timer);
  }

  static initializeAll(): void {
    document.querySelectorAll<HTMLElement>('.nad-promo-topbar').forEach((el) => {
      if (!(el as any)._nadComponentInstance) {
        (el as any)._nadComponentInstance = new NADPromoTopbar(el);
      }
    });
  }
}
